module.exports = __webpack_public_path__ + "static/media/trading-autohor.501e163a.png";